import React from "react";

const StatCard = ({ label, value, icon: Icon, accent, iconBg }) => {
  return (
    <div className="group relative min-w-0 overflow-hidden rounded-xl border border-gray-200 bg-white p-3 shadow-sm transition hover:shadow-md sm:p-4">
      <div className={`absolute inset-y-0 left-0 w-1 ${accent}`} />

      <div className="flex min-w-0 items-center gap-3 pl-1 sm:pl-2">
        <div
          className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${iconBg}`}
        >
          <Icon size={18} />
        </div>

        <div className="min-w-0 flex-1">
          <p className="whitespace-normal break-words text-[10.5px] font-semibold uppercase leading-[14px] tracking-wide text-gray-400">
            {label}
          </p>

          <p className="mt-0.5 break-words text-xl font-extrabold leading-tight text-gray-900">
            {value}
          </p>
        </div>
      </div>
    </div>
  );
};

export default StatCard;